export default "__VITE_ASSET__BNHeV3n5__"